import { ComponentClassNames } from '../../util/classNames';
import { getGutterValue } from '../../util/styles/gutters';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

type ParagraphClassNames = ComponentClassNames<'paragraph'>;

export const getClassNames = memoizeFunction(
  (): ParagraphClassNames =>
    mergeStyleSets({
      paragraph: [
        {
          margin: `0 0 ${getGutterValue(4, true)}`,
          lineHeight: 'inherit',
        },
      ],
    })
);
